import { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/main.scss';

import { Input } from 'dibs-elements/exports/Input';

function Text(props) {
    const {
        autoComplete,
        autoFocus,
        maxLength,
        dataTn,
        error,
        isBlurred,
        disabled,
        name,
        fieldSize,
        onBlur,
        onChange,
        pattern,
        placeholder,
        type,
        value,
        wrapperClass,
        onFocus,
        disableAutocomplete,
    } = props;

    const showError = !disabled && isBlurred && !!error;
    const hasValidText = isBlurred && !!value && !showError;

    const cursorPositionRef = useRef(value.length);
    const inputNodeRef = useRef(null);

    const handleChange = useCallback(
        event => {
            cursorPositionRef.current = event.target.selectionStart;
            inputNodeRef.current = event.target;
            onChange({ name, value: event.target.value, event });
        },
        [onChange, name]
    );

    useEffect(() => {
        if (inputNodeRef.current) {
            inputNodeRef.current.setSelectionRange(
                cursorPositionRef.current,
                cursorPositionRef.current
            );
        }
    }, [value]);

    return (
        <div className={wrapperClass} data-field={name}>
            <Input
                type={type}
                dataTn={dataTn}
                name={name}
                value={value}
                pattern={pattern}
                size={fieldSize}
                maxLength={maxLength}
                placeholder={placeholder}
                errorMessage={showError && error}
                className={styles.input}
                autoComplete={disableAutocomplete ? 'turn-off-autocomplete' : autoComplete}
                autoFocus={autoFocus}
                disabled={disabled}
                hasValidText={hasValidText}
                hasAnimatedPlaceholder
                onChange={handleChange}
                onBlur={event => onBlur({ name, value: event.target.value })}
                onFocus={event => onFocus({ name, value: event.target.value })}
                maskForPrivacy
                showError
            />
        </div>
    );
}

Text.propTypes = {
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    dataTn: PropTypes.string.isRequired,
    error: PropTypes.string,
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    pattern: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    wrapperClass: PropTypes.string,
    disableAutocomplete: PropTypes.bool,
};

Text.defaultProps = {
    dataTn: '',
    autoComplete: 'on',
    autoFocus: false,
    maxLength: 256,
    isBlurred: false,
    disabled: false,
    fieldSize: null,
    onBlur() {},
    onFocus() {},
    placeholder: '',
    type: 'text',
    wrapperClass: '',
};

export default Text;
